import React from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import AsyncSelect from "react-select/async";
import { asyncSelectCustomStyles } from "../../util/styles";
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";
import { genreOptions, userTypeOptions, maritalStatusOptions, childrenOptions, ageOptions } from "./FormOptions";
import "./StoreModal.css";

class StoreModal extends React.Component {

    initialState = {
        id: null,
        user_type: null,
        cep: '',
        age: null,
        genre: null,
        marital_status: null,
        children: null,
        income: '',
        property_of_interest: '',
        errors: {},
        saving: false,
    };

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            if (this.props.user) {
                this.setState({
                    id: this.props.user.id,
                    user_type: userTypeOptions.find(option => option.label === this.props.user.user_type)?.value || null,
                    cep: this.props.user.cep,
                    age: parseInt(this.props.user.age),
                    genre: genreOptions.find(option => option.label === this.props.user.genre)?.value || null,
                    marital_status: maritalStatusOptions.find(option => option.label === this.props.user.marital_status)?.value || null,
                    children: this.props.user.children,
                    income: this.props.user.income,
                    property_of_interest: this.props.user.property_of_interest || '',
                    errors: {}
                });
            } else {
                this.setState(this.initialState);
            }
        }
    }

    handleInputChange = (e) => {
        let errors = { ...this.state.errors };
        if (errors[e.target.name]) {
            delete errors[e.target.name];
        }
        this.setState({ [e.target.name]: e.target.value, errors });
    }

    handleDropdownChange = (e, name) => {
        let errors = { ...this.state.errors };
        if (errors[name]) {
            delete errors[name];
        }
        this.setState({ [name]: e.value, errors });
    }

    save = async () => {
        this.setState({ errors: {}, saving: true });

        const isEdit = !!this.state.id;
        const url = isEdit
            ? `/geo-referenciamento/update/${this.state.id}`
            : "/geo-referenciamento/create";

        axios.post(url, this.state)
            .then((response) => {
                if (response.data.status === "Success") {
                    this.props.onHide();
                    this.props.toast();
                    this.props.reloadBuildings();
                    this.setState(this.initialState);
                }
            })
            .catch((error) => {
                this.setState({ saving: false });
                if (error.response && error.response.status === 422) {
                    this.setState({ errors: error.response.data.errors || {} });
                } else {
                    console.error("Erro ao salvar:", error);
                }
            });
    };

    getFormErrorMessage = (name) => {
        if (!this.state.errors[name]) return null;

        const message = Array.isArray(this.state.errors[name])
            ? this.state.errors[name][0]
            : this.state.errors[name];

        return (
            <small style={{ color: '#e24c4c', display: 'block', marginTop: '4px' }}>
                {message}
            </small>
        );
    };

    renderFooter() {
        const { saving, id } = this.state;
        return (
            <div className="store-modal-footer">
                <button
                    className="btn btn-success btn-salvar bold"
                    onClick={this.save}
                    disabled={saving}
                    style={{ padding: '10px 30px', borderRadius: '0px' }}
                >
                    {saving ? (
                        <>
                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
                            SALVANDO...
                        </>
                    ) : (
                        id ? "ATUALIZAR" : "SALVAR"
                    )}
                </button>
            </div>
        );
    }

    render() {
        const isEdit = !!this.state.id;

        const inputStyle = {
            width: '100%',
            borderRadius: '0px',
            border: '1px solid #ced4da',
            minHeight: '42px',
            boxShadow: 'none',
        };

        const errorInputStyle = { ...inputStyle, border: '1px solid #e24c4c' };

        const labelStyle = {
            display: 'block',
            marginBottom: '0.5rem',
            fontFamily: '"Archivo Expanded", Arial, sans-serif',
            fontWeight: '400',
            fontSize: '17.3px',
            color: '#5b595b',
        };

        const colStyle = { display: 'flex', flexDirection: 'column', gap: '15px' };

        const getStyle = (fieldName) => this.state.errors[fieldName] ? errorInputStyle : inputStyle;
        const getClass = (fieldName) => this.state.errors[fieldName] ? 'p-invalid' : '';

        return (
            <Dialog
                header={isEdit ? "Editar Cliente" : "Adicionar Cliente"}
                visible={this.props.show}
                modal
                closable
                onHide={this.props.onHide}
                footer={this.renderFooter()}
                className="store-modal-dialog"
                style={{ width: '50vw', minWidth: '600px', marginTop: '5%' }}
            >
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', padding: '1rem 0' }}>

                    <div style={colStyle}>
                        <div>
                            <label style={labelStyle}>Tipo do cliente *</label>
                            <Dropdown
                                value={this.state.user_type}
                                options={userTypeOptions}
                                onChange={(e) => this.handleDropdownChange(e, 'user_type')}
                                style={getStyle('user_type')}
                                className={getClass('user_type')}
                                placeholder="Selecione..."
                            />
                            {this.getFormErrorMessage('user_type')}
                        </div>

                        <div>
                            <label style={labelStyle}>Idade *</label>
                            <Dropdown
                                value={this.state.age}
                                options={ageOptions}
                                onChange={(e) => this.handleDropdownChange(e, 'age')}
                                style={getStyle('age')}
                                className={getClass('age')}
                                placeholder="Selecione..."
                                filter
                            />
                            {this.getFormErrorMessage('age')}
                        </div>

                        <div>
                            <label style={labelStyle}>Estado civil *</label>
                            <Dropdown
                                value={this.state.marital_status}
                                options={maritalStatusOptions}
                                onChange={(e) => this.handleDropdownChange(e, 'marital_status')}
                                style={getStyle('marital_status')}
                                className={getClass('marital_status')}
                                placeholder="Selecione..."
                            />
                            {this.getFormErrorMessage('marital_status')}
                        </div>

                        <div>
                            <label style={labelStyle}>Renda *</label>
                            <InputText
                                name="income"
                                value={this.state.income}
                                onChange={this.handleInputChange}
                                style={getStyle('income')}
                                className={getClass('income')}
                            />
                            {this.getFormErrorMessage('income')}
                        </div>
                    </div>

                    <div style={colStyle}>
                        <div>
                            <label style={labelStyle}>CEP *</label>
                            <InputText
                                name="cep"
                                value={this.state.cep}
                                onChange={this.handleInputChange}
                                style={getStyle('cep')}
                                className={getClass('cep')}
                            />
                            {this.getFormErrorMessage('cep')}
                        </div>

                        <div>
                            <label style={labelStyle}>Gênero *</label>
                            <Dropdown
                                value={this.state.genre}
                                options={genreOptions}
                                onChange={(e) => this.handleDropdownChange(e, 'genre')}
                                style={getStyle('genre')}
                                className={getClass('genre')}
                                placeholder="Selecione..."
                            />
                            {this.getFormErrorMessage('genre')}
                        </div>

                        <div>
                            <label style={labelStyle}>Filhos</label>
                            <Dropdown
                                value={this.state.children}
                                options={childrenOptions}
                                onChange={(e) => this.handleDropdownChange(e, 'children')}
                                style={getStyle('children')}
                                className={getClass('children')}
                                placeholder="Selecione..."
                            />
                            {this.getFormErrorMessage('children')}
                        </div>

                        <div>
                            <label style={labelStyle}>Empreendimento</label>
                            <AsyncSelect
                                styles={{
                                    ...asyncSelectCustomStyles,
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    control: (base, state) => ({
                                        ...asyncSelectCustomStyles.control(base, state),
                                        ...(this.state.errors.property_of_interest ? { border: '1px solid #e24c4c !important' } : {}),
                                    }),
                                }}
                                components={reactSelectIcons}
                                placeholder="Digite para buscar..."
                                isMulti={false}
                                closeMenuOnSelect={true}
                                loadOptions={this.props.searchBuildings}
                                onChange={(option) => this.setState({ property_of_interest: option ? option.label : '' })}
                                value={this.state.property_of_interest ? { label: this.state.property_of_interest, value: this.state.property_of_interest } : null}
                                noOptionsMessage={() => "Digite para buscar..."}
                                loadingMessage={() => "Carregando..."}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />
                            {this.getFormErrorMessage('property_of_interest')}
                        </div>
                    </div>

                </div>
            </Dialog>
        );
    }
}

export default StoreModal;
